import {
    ACCEPT_CUSTOMER_INVITE_FAIL,
    ACCEPT_CUSTOMER_INVITE_REQUEST,
    ACCEPT_CUSTOMER_INVITE_SUCCESS,
    ACCEPT_HEAD_NURSE_INVITE_FAIL,
    ACCEPT_HEAD_NURSE_INVITE_REQUEST,
    ACCEPT_HEAD_NURSE_INVITE_SUCCESS,
    ADD_NURSE_BY_HN_FAIL,
    ADD_NURSE_BY_HN_REQUEST,
    ADD_NURSE_BY_HN_SUCCESS,
    CLEAR_HEAD_NURSE_MESSAGE,
    CLEAR_INVITED_CUSTOMER_DATA,
    DELETE_CUSTOMER_FAIL,
    DELETE_CUSTOMER_REQUEST,
    DELETE_CUSTOMER_SUCCESS,
    EDIT_HEAD_NURSE_PROFILE_FAIL,
    EDIT_HEAD_NURSE_PROFILE_REQUEST,
    EDIT_HEAD_NURSE_PROFILE_SUCCESS,
    EDIT_SENIOR_BY_HN_FAIL,
    EDIT_SENIOR_BY_HN_REQUEST,
    EDIT_SENIOR_BY_HN_SUCCESS,
    GET_NURSE_BY_HN_ID_FAIL,
    GET_NURSE_BY_HN_ID_REQUEST,
    GET_NURSE_BY_HN_ID_SUCCESS,
    GET_NURSES_BY_HN_FAIL,
    GET_NURSES_BY_HN_REQUEST,
    GET_NURSES_BY_HN_SUCCESS,
    GET_SENIORS_BY_HN_FAIL,
    GET_SENIORS_BY_HN_REQUEST,
    GET_SENIORS_BY_HN_SUCCESS,
    HeadNurseAction,
    HeadNurseState,
    INVITE_CUSTOMER_FAIL,
    INVITE_CUSTOMER_REQUEST,
    INVITE_CUSTOMER_SUCCESS,
    INVITE_HEAD_NURSE_FAIL,
    INVITE_HEAD_NURSE_REQUEST,
    INVITE_HEAD_NURSE_SUCCESS,
    INVITED_CUSTOMER_DATA_FAIL,
    INVITED_CUSTOMER_DATA_REQUEST,
    INVITED_CUSTOMER_DATA_SUCCESS,
    LOGIN_USER_REQUEST,
} from "../types";

export const headNurseInitialState: HeadNurseState = {
    headNurseInvite: {
        data: {
            firstName: "",
            lastName: "",
            email: "",
            seniorHomeIds: -1,
        },
        loading: false,
        error: null,
    },
    addNurse: {
        data: {
            firstName: "",
            lastName: "",
            email: "",
            isNurse: true,
            seniorHomeIds: -1,
        },
        loading: false,
        error: null,
    },
    customerInvite: {
        data: {
            firstName: "",
            lastName: "",
            email: "",
        },
        loading: false,
        error: null,
    },
    invitedCustomerData: {
        data: {
            id: null,
            firstName: "",
            lastName: "",
            email: "",
            token: "",
            seniorHomeIds: null,
            createdAt: null,
            updatedAt: null,
            deletedAt: null,
            username: "",
            role: "",
        },
        loading: false,
        error: null,
    },
    acceptCustomerInvite: {
        loading: false,
        error: null,
        data: null,
    },
    nurses: {
        list: [],
        loading: false,
        error: null,
    },
    nurse: {
        data: null,
        loading: false,
        error: null,
    },
    seniors: {
        list: [],
        loading: false,
        error: null,
    },

    editSenior: {
        loading: false,
        error: null,
        data: null,
    },
    message: {},

    editHeadNurseProfile: {
        loading: false,
        error: null,
        data: {},
    },
    loading: false,
    error: null,
};

const headNurse = (state = headNurseInitialState, action: HeadNurseAction): HeadNurseState => {
    switch (action.type) {
        case INVITE_HEAD_NURSE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                message: {},
            };
        case INVITE_HEAD_NURSE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                message: {},
            };
        case INVITE_HEAD_NURSE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                message: action.payload.error,
            };
        case ADD_NURSE_BY_HN_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                message: {},
            };
        case ADD_NURSE_BY_HN_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                message: {},
            };
        case ADD_NURSE_BY_HN_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };
        case ACCEPT_HEAD_NURSE_INVITE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                message: {},
            };
        case ACCEPT_HEAD_NURSE_INVITE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                message: { status: 200, message: "Head nurse invite accepted successfully" },
            };

        case ACCEPT_HEAD_NURSE_INVITE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                message: action.payload.error,
            };

        case GET_NURSE_BY_HN_ID_REQUEST:
            return {
                ...state,
                nurse: {
                    ...state.nurse,
                    loading: true,
                    error: null,
                },
            };
        case GET_NURSE_BY_HN_ID_SUCCESS:
            return {
                ...state,
                nurse: {
                    ...state.nurse,
                    data: action.payload,
                    loading: false,
                    error: null,
                },
            };
        case GET_NURSE_BY_HN_ID_FAIL:
            return {
                ...state,
                nurse: {
                    ...state.nurse,
                    loading: false,
                    error: action.payload.error,
                },
            };

        // Get Seniors by Head Nurse
        case GET_SENIORS_BY_HN_REQUEST:
            return {
                ...state,
                seniors: {
                    ...state.seniors,
                    loading: true,
                    error: null,
                },
            };
        case GET_SENIORS_BY_HN_SUCCESS:
            return {
                ...state,
                seniors: {
                    ...state.seniors,
                    list: action.payload,
                    loading: false,
                    error: null,
                },
            };
        case GET_SENIORS_BY_HN_FAIL:
            return {
                ...state,
                seniors: {
                    ...state.seniors,
                    loading: false,
                    error: action.payload.error,
                },
            };

        case INVITE_CUSTOMER_REQUEST:
            return {
                ...state,
                customerInvite: {
                    ...state.customerInvite,
                    loading: true,
                    error: null,
                },
                message: {},
            };
        case INVITE_CUSTOMER_SUCCESS:
            return {
                ...state,
                customerInvite: {
                    ...state.customerInvite,
                    loading: false,
                    error: null,
                },
                message: {},
            };
        case INVITE_CUSTOMER_FAIL:
            return {
                ...state,
                customerInvite: {
                    ...state.customerInvite,
                    loading: false,
                    error: action.payload.error,
                },
                message: action.payload.error,
            };
        case ACCEPT_CUSTOMER_INVITE_REQUEST:
            return {
                ...state,
                acceptCustomerInvite: {
                    ...state.acceptCustomerInvite,
                    loading: true,
                    error: null,
                },
                message: {},
            };
        case ACCEPT_CUSTOMER_INVITE_SUCCESS:
            return {
                ...state,
                acceptCustomerInvite: {
                    ...state.acceptCustomerInvite,
                    loading: false,
                    error: null,
                },
                message: { status: 200, message: "Customer invite accepted successfully" },
            };
        case ACCEPT_CUSTOMER_INVITE_FAIL:
            return {
                ...state,
                acceptCustomerInvite: {
                    ...state.acceptCustomerInvite,
                    loading: false,
                    error: action.payload.error,
                },
                message: action.payload.error,
            };
        case GET_NURSES_BY_HN_REQUEST:
            return {
                ...state,
                nurses: {
                    ...state.nurses,
                    loading: true,
                    error: null,
                },
            };
        case GET_NURSES_BY_HN_SUCCESS:
            return {
                ...state,
                nurses: {
                    list: action.payload,
                    loading: false,
                    error: null,
                },
            };
        case GET_NURSES_BY_HN_FAIL:
            return {
                ...state,
                nurses: {
                    ...state.nurses,
                    loading: false,
                    error: action.payload.error,
                },
            };

        case EDIT_SENIOR_BY_HN_REQUEST:
            return {
                ...state,
                editSenior: {
                    ...state.editSenior,
                    loading: true,
                    error: null,
                },
                message: {},
            };
        case EDIT_SENIOR_BY_HN_SUCCESS:
            return {
                ...state,
                editSenior: {
                    ...state.editSenior,
                    loading: false,
                    error: null,
                    data: action.payload,
                },
                message: {},
            };
        case EDIT_SENIOR_BY_HN_FAIL:
            return {
                ...state,
                editSenior: {
                    ...state.editSenior,
                    loading: false,
                    error: action.payload.error,
                },
                message: action.payload.error,
            };

        case DELETE_CUSTOMER_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                message: {},
            };

        case DELETE_CUSTOMER_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                message: { status: 200, message: "Customer deleted successfully" },
            };

        case DELETE_CUSTOMER_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                message: action.payload.error,
            };

        case EDIT_HEAD_NURSE_PROFILE_REQUEST:
            return {
                ...state,
                editHeadNurseProfile: {
                    ...state.editHeadNurseProfile,
                    loading: true,
                    error: null,
                },
                message: {},
            };

        case EDIT_HEAD_NURSE_PROFILE_SUCCESS:
            return {
                ...state,
                editHeadNurseProfile: {
                    ...state.editHeadNurseProfile,
                    loading: false,
                    error: null,
                    data: action.payload,
                },
                message: {},
            };

        case EDIT_HEAD_NURSE_PROFILE_FAIL:
            return {
                ...state,
                editHeadNurseProfile: {
                    ...state.editHeadNurseProfile,
                    loading: false,
                    error: action.payload,
                    data: {},
                },
                message: {},
            };

        case INVITED_CUSTOMER_DATA_REQUEST:
            return {
                ...state,
                invitedCustomerData: {
                    ...state.invitedCustomerData,
                    loading: true,
                    error: null,
                },
            };
        case INVITED_CUSTOMER_DATA_SUCCESS:
            return {
                ...state,
                invitedCustomerData: {
                    ...state.invitedCustomerData,
                    data: action.payload,
                    loading: false,
                    error: null,
                },
            };
        case INVITED_CUSTOMER_DATA_FAIL:
            return {
                ...state,
                invitedCustomerData: {
                    ...state.invitedCustomerData,
                    loading: false,
                    error: action.payload.error,
                },
            };

        case CLEAR_INVITED_CUSTOMER_DATA:
            return {
                ...state,
                invitedCustomerData: {
                    ...state.invitedCustomerData,
                    data: headNurseInitialState.invitedCustomerData.data,
                    loading: false,
                    error: null,
                },
            };
        case CLEAR_HEAD_NURSE_MESSAGE:
            return {
                ...state,
                message: {},
            };
        case LOGIN_USER_REQUEST:
            return headNurseInitialState;
        default:
            return state;
    }
};

export default headNurse;
